import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import exportValue from "../apiconfig";
import { borderRadius } from "@mui/system";
import moment from "moment";
import Moment from "react-moment";

const Sub_header = () => {  
 

  let navigate = useNavigate();
 
  const [notificationState,setNotificationState]=React.useState({

    notifications:[],

    unread_count:0

})
  const [readState, setreadState] = React.useState(false);
  let loginDetail = localStorage.getItem('admin_login');
 // const [state, setState] = useState({ full_name: "" });
 
  //console.log("e => ", loginDetail);
  if(loginDetail == null) {
    window.location.href = '/login';
    //navigate('/login')
  }else {    
    loginDetail = JSON.parse(localStorage.getItem('admin_login'));
   // setState(JSON.parse(loginDetail))
  }
  let admindata = {};
if (localStorage.getItem('admin_login')) {
  admindata = JSON.parse(localStorage.getItem('admin_login'));
  console.log("admindata------>  -  ",admindata);
  //navigate('/home') 
}

const ndr_detail = () => {
  let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/unread_ndr`;
  let sendData = {};

  axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
    setreadState(res.data.show_popup)
  }).catch((e) => {
    
  })
}

const logout = () =>{
  console.log("userDetail ===>   ");

  let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/user_logout`;
    let sendData = {admin_id:loginDetail.admin_id};
    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
        console.log("res ", res);
        if (res.data.status==true) {
          localStorage.removeItem('admin_login');
    localStorage.clear();
    navigate('/login')
 
        }else {
        
        }

    }).catch((e) => {
    });
}

React.useEffect(()=>{
 ndr_detail()
},[])

React.useEffect(()=>{

  getRecentNotifications();


  const interval = setInterval(()=>{
      getRecentNotifications()

  },30000);
  return ()=>clearInterval(interval)
},[])

const getRecentNotifications=()=>{
 axios.post(
  exportValue.host+"/"+
  exportValue.version+"/"+
  exportValue.api+
  "/recent_notifications",
  {},
  {
  headers:exportValue.headers
  }
  )
  .then(res=>{
  if(res.data.status){
  setNotificationState({
  notifications:res.data.notifications,
  unread_count:res.data.unread_count
  })
  }
  })
  .catch(err=>{
  console.log(err)
  })
  }

  const openNotification=async(item)=>{
 try{
    await axios.post(
    exportValue.host+"/"+
    exportValue.version+"/"+
    exportValue.api+
    "/mark_notification_read",
    {
    notification_id:item._id
    },
    {
    headers:exportValue.headers
    }
    )
    setNotificationState(prev=>({
    ...prev,
    notifications:prev.notifications.map(x=>{
    if(x._id===item._id){
    return{
    ...x,
    is_read:true
    }
    }
    return x
    }),
    unread_count:Math.max(0,prev.unread_count-1)
    }))
    window.location.href=item.redirect_url
    }
    catch(e){
    console.log(e)
    }
    }

    const viewAllNotifications=async()=>{
      await axios.post(
      
      exportValue.host+"/"+
      exportValue.version+"/"+
      exportValue.api+
      "/mark_all_notifications",
      {},
      {
      headers:exportValue.headers
      }
      )
      window.location.href ="/notification_log"
      }

  return (
    <>
  
<section class="bg-white border-bottom header_main_2">
  <div class="">

    <section>
      <nav class="navbar navbar-expand-sm">
        <div class="container-fluid">

            
          <a class="navbar-brand" href="/dashboard"><h5>JetPost</h5></a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="mynavbar">
            <ul class="navbar-nav me-auto">
            
            </ul>
            <ul class="navbar-nav align-items-center">
              {readState?
              <div className='ms-4 mt-1'>
            <div class="ndr-zoom"><a href="/ndr_shipments?type=0" style={{color:"red"}}>NDR</a></div>
             
            </div>:""}
            <li className="nav-item dropdown me-3">


<a

className="nav-link"

href="#"

data-bs-toggle="dropdown"

>


<div className="position-relative">


<i className="fa fa-envelope fs-4"></i>


{

notificationState.unread_count>0


&&


<span className="notification-dot"></span>


}


</div>


</a>




<div className="dropdown-menu dropdown-menu-end shadow-sm">



{

notificationState.notifications.length>0


?


notificationState.notifications.map(item=>(


<div


key={item._id}


className={`dropdown-item ${

!item.is_read

?

"notification-unread"

:

""

}`}



onClick={()=>openNotification(item)}


style={{cursor:"pointer"}}



>



<div className="d-flex">


<div className="me-3">


{


!item.is_read


?


<i className="fa fa-envelope text-primary"></i>


:


<i className="fa fa-envelope-open"></i>


}


</div>



<div>


<h6>


{item.title}

</h6>



<p>


{item.message}

</p>



<small>


<Moment format="DD MMM YYYY hh:mm A">

{item.created_at*1000}

</Moment>



</small>



</div>



</div>


</div>

))


:


<div className="p-3">


No notifications


</div>



}




<div className="p-2">


<button


className="btn btn-primary w-100"


onClick={viewAllNotifications}


>


View all notifications


</button>



</div>




</div>



</li>
              <li class="nav-item dropdown ms-lg-3">
                 <a class="nav-link dropdown-toggle pt-1 px-0" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <div class="media d-flex align-items-center">
                       <img class="avatar rounded-circle" alt="Image placeholder" src="../../../assets/img/team/profile-picture-2.jpg"/>
                       <div class="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                          <span class="mb-0 font-small fw-bold text-gray-900">Welcome Admin!</span>
                       </div>
                    </div>
                 </a>
                 <div class="dropdown-menu dashboard-dropdown dropdown-menu-end mt-2 py-1">
                    <a class="dropdown-item d-flex align-items-center" href="/my_profile">
                       <svg class="dropdown-icon text-gray-400 me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd"></path>
                       </svg>
                       My Profile
                    </a>
                    <a class="dropdown-item d-flex align-items-center" href="/change_password">
                       <svg class="dropdown-icon text-gray-400 me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"></path>
                       </svg>
                       Change Password
                    </a>
                    <div role="separator" class="dropdown-divider my-1"></div>
                    <a class="dropdown-item d-flex align-items-center" onClick={()=>logout()}>
                       <svg class="dropdown-icon text-danger me-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                       </svg>
                       Logout
                    </a>
                 </div>
              </li>
           </ul>
          </div>
        </div>
      </nav>
    </section>
    {/* <!-- end nav bar --> */}
  </div>
</section>

  </>
  )
}

export default Sub_header